<template>
  <!-- <div class="pic-swipe-wrapper" @click="hide()" @touchmove.prevent> -->
  <div class="pic-swipe-wrapper" @touchmove.prevent>
    <transition name="swipe-fade">
      <div class="pic-swipe-inner" v-show="isPreview">
        <span class="close_icon" @click="hide()"></span>
        <swipe
          :auto="0"
          :defaultIndex="index"
          :continuous="false"
          class="pic-show"
          ref="swiperCom"
        >
          <swipe-item v-for="(item, i) in items" :key="i">
            <div class="item">
              <!-- <span class="close_icon" @click="hide()"></span> -->
              <img v-lazy="item.picUrl" />
              <span class="img_name"> {{ item.credentialsName }} </span>
            </div>
            <!-- <img v-lazy="item"> -->
          </swipe-item>
        </swipe>
        <spinner type="fading-circle" class="loading-spinner"></spinner>
      </div>
    </transition>
  </div>
</template>
<script>
import { Swipe, SwipeItem, Spinner } from 'mint-ui'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    index() {
      if (
        typeof this.$route.query.index != 'undefined' &&
        this.$refs.swiperCom
      ) {
        this.$refs.swiperCom.reInitPages()
      }
      return parseInt(this.$route.query.index, 10) || 0
    },
    isPreview() {
      return this.$route.query.preview
    }
  },
  created() {
    let query = this.$route.query
    if (query.preview) {
      window.history.go(-1)
    }
  },
  mounted() {
    const wrapper = document.querySelector('.pic-swipe-wrapper')
    if (wrapper) {
      wrapper.addEventListener('transitionend', () => {
        if (!this.isPreview) {
          // this.$store.commit('setPreviewImages', [])
          this.$emit('clear')
        }
      })
    }
  },
  methods: {
    hide() {
      this.$router.back()
    }
  },
  components: {
    Swipe,
    SwipeItem,
    Spinner
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/mixin.scss';
.pic-swipe-inner {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  // padding: rem(30px) 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 1);
  transition: left 0.4s cubic-bezier(0.12, 0.67, 0.73, 0.96);

  .close_icon {
    position: absolute;
    z-index: 10000;
    left: rem(30px);
    // top: rem(132px);
    top: rem(60px);
    // display: flex;
    width: rem(44px);
    height: rem(44px);
    // background-image: url("../../../../assets/images/icon-delete@3x.png");
    background-image: url('../../../../assets/images/icon-delete-square@3x.png');
    background-size: rem(44px);
  }

  .img_name {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    // top: 75%;
    bottom: rem(210px);
    font-family: PingFangSC-Regular;
    height: rem(50px);
    padding: rem(7px) rem(34px);
    background: #7f7f7f;
    border-radius: rem(25px);
    font-size: rem(30px);
    color: #ffffff;
  }

  img {
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateY(-50%);
    // top: rem(535px);
    // max-width: 100%;
    max-height: rem(553px);
    max-width: rem(750px);
    object-fit: cover;
    // max-height: 100%;
    // max-height: 70%;
    transform: translate3d(-50%, -50%, 0);
  }

  img[lazy='loading'] {
    background: none;
    width: 100%;
    height: auto;
    margin: auto;
  }
  .pic-show {
    position: relative;
    z-index: 5;
  }
  .loading-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -14px;
    margin-top: -14px;
  }
}
.pic-swipe-show {
  left: 0;
  transform: translateZ(0);
}
.pic-swipe-fade {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.swipe-fade-enter,
.swipe-fade-leave-active {
  opacity: 0;
}
.swipe-fade-leave-active,
.swipe-fade-enter-active {
  transition: opacity 300ms;
}

/deep/.mint-swipe-indicators {
  bottom: rem(68px);
}
</style>
